function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
//
//  This file is also used by other web components (ts-modal-ujs-transaction)
//
export default updateDomFromFragmentString;
import { default as highlight } from './effect_highlight.js';
import { append_html, prepend_html, replace_html, update_html, html_after, html_before } from 'wc-util';
function updateDomFromFragmentString(new_dom_fragment, _ref) {
  var _ref$append = _ref.append,
    append = _ref$append === void 0 ? null : _ref$append,
    _ref$prepend = _ref.prepend,
    prepend = _ref$prepend === void 0 ? null : _ref$prepend,
    _ref$before = _ref.before,
    before = _ref$before === void 0 ? null : _ref$before,
    _ref$after = _ref.after,
    after = _ref$after === void 0 ? null : _ref$after,
    _ref$update = _ref.update,
    update = _ref$update === void 0 ? null : _ref$update,
    _ref$replace = _ref.replace,
    replace = _ref$replace === void 0 ? null : _ref$replace;
  if (new_dom_fragment) {
    var target_el_id = append || prepend || after || before || update || replace,
      target_el = document.getElementById(target_el_id);
    if (target_el) {
      // explicit target element ID given
      if (append) {
        var _iterator = _createForOfIteratorHelper(elementsFromString(new_dom_fragment)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var new_dom_el = _step.value;
            append_html(target_el, new_dom_el);
            highlight(new_dom_el);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (prepend) {
        var _iterator2 = _createForOfIteratorHelper(elementsFromString(new_dom_fragment).reverse()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _new_dom_el = _step2.value;
            prepend_html(target_el, _new_dom_el);
            highlight(_new_dom_el);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } else if (before) {
        var _iterator3 = _createForOfIteratorHelper(elementsFromString(new_dom_fragment).reverse()),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _new_dom_el2 = _step3.value;
            html_before(target_el, _new_dom_el2);
            highlight(_new_dom_el2);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } else if (after) {
        var _iterator4 = _createForOfIteratorHelper(elementsFromString(new_dom_fragment)),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _new_dom_el3 = _step4.value;
            html_after(target_el, _new_dom_el3);
            highlight(_new_dom_el3);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else if (update) {
        update_html(target_el, new_dom_fragment);
        highlight(target_el);
      } else if (replace) {
        replace_html(target_el, new_dom_fragment);
        var _new_dom_el4 = document.getElementById(target_el_id);
        _new_dom_el4 && highlight(_new_dom_el4);
      }
    } else if (target_el_id) {
      console.log("Can't find target element with ID", target_el_id);
    } else {
      // no explicit target element given
      var _iterator5 = _createForOfIteratorHelper(elementsFromString(new_dom_fragment)),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var root_node = _step5.value;
          replaceDomFor(root_node);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }
}

// returns a HTMLCollection
function elementsFromString(fragment_string) {
  var root = document.createElement("template"); // using "template" so that TDs etc. will work too
  root.innerHTML = fragment_string;
  return Array.from(root.content.children); // Return Array instead of HTMLCollection to make it not "live"
}
function replaceDomFor(new_dom_el) {
  var target_el = document.getElementById(new_dom_el.id);
  if (target_el) {
    replace_html(target_el, new_dom_el);
    highlight(new_dom_el);
  } else if (new_dom_el.nodeName == "SCRIPT") {
    eval(new_dom_el.text);
  } else {
    console.log("Don't know where to put", new_dom_el);
  }
}